import config from "../../../config";

// Components & Molecules
import PageHero from "../PageHero";
import PageSection from "../PageSection";
import FoodHow from "./FoodHow";
import PageForm from "../PageForm";
import Button from "../../../components/Mobile/Button";

// Icons & Images
import hero_bka_a from "../../../assets/img/FoodEntrepreneurs/Mobile/hero_bkg_a.jpg";
import hero_bka_b from "../../../assets/img/FoodEntrepreneurs/Mobile/hero_bkg_b.jpg";
import sect1_img from "../../../assets/img/FoodEntrepreneurs/Mobile/sect1_img.jpg";
import sect2_img from "../../../assets/img/FoodEntrepreneurs/Mobile/sect2_img.jpg";
import sect3_img from "../../../assets/img/FoodEntrepreneurs/Mobile/sect3_img.jpg";
import sect4_img from "../../../assets/img/FoodEntrepreneurs/Mobile/sect4_img.jpg";
import sect5_img from "../../../assets/img/FoodEntrepreneurs/Mobile/sect5_img.jpg";
import sect6_img from "../../../assets/img/FoodEntrepreneurs/Mobile/sect6_img.jpg";
import sect7_img from "../../../assets/img/FoodEntrepreneurs/Mobile/sect7_img.jpg";

import { ReactComponent as TailedArrowRightIcon } from "../../../icons/TailedArrowRightIcon.svg";

var webUrl = config?.webUrl;

const FoodSections = () => {
  return (
    <>
      {/* Hero Section */}
      <PageHero
        bkg_a={hero_bka_a}
        bkg_b={hero_bka_b}
        sub_head={"Food Entrepreneurs"}
        main_head={
          <>
            <span className="text-primaryDark-400"> Expand Beyond </span> Your
            Home Kitchen
          </>
        }
        description="Access culinary resources and grow your fledging food business beyond your home with HomeCook’s reliable platform that provides resources & connections for food entrepreneurs."
        children={
          <>
            <a href={webUrl} target="_blank" rel="noreferrer">
              <Button
                label={
                  <>
                    View Resource Pantry
                    <TailedArrowRightIcon className="w-[20px] h-[20px]" />
                  </>
                }
                variant="secondary"
              />
            </a>
          </>
        }
      />

      {/* Section One */}
      <PageSection
        imgSrc={sect1_img}
        greyBkg
        header={
          <>
            <span className="text-primaryDark-400"> Access kitchens </span> That
            Match Your Goals
          </>
        }
        description="We’ll connect you with vetted kitchen spaces aligned to your cuisine, capacity, budget and location needs - so you can focus on growth."
        button={{
          label: "View Kitchens",
          onClick: () => {
            window.open(webUrl + "/kitchen", "_blank");
          },
        }}
      />

      {/* Section Two */}
      <PageSection
        imgSrc={sect2_img}
        header={
          <>
            <span className="text-primaryDark-400"> Get Guidance On </span>{" "}
            Compliance Documentation
          </>
        }
        description="Access the permits, licenses, guidelines, and compliance resources you need to operate confidently and legally - without the confusion or guesswork."
        button={{
          label: "View Documentations",
          onClick: () => {
            window.open(webUrl + "/documentation", "_blank");
          },
        }}
      />

      {/* Section Three */}
      <PageSection
        imgSrc={sect3_img}
        greyBkg
        header={
          <>
            <span className="text-primaryDark-400">
              Grow Your Business Through
            </span>{" "}
            Practical Culinary Training
          </>
        }
        description="Access hands-on programs and expert-led sessions designed to refine your production processes, improve quality and consistency, and help you scale your food business with confidence."
        button={{
          label: "View Culinary Trainings",
          onClick: () => {
            window.open(webUrl + "/training", "_blank");
          },
        }}
      />

      {/* Section Four */}
      <PageSection
        imgSrc={sect4_img}
        header={
          <>
            <span className="text-primaryDark-400"> Unlock Funding to </span>{" "}
            Fuel Your Growth
          </>
        }
        description="Discover funding opportunities, grants, and financial support tailored for food entrepreneurs - helping you invest in equipment, production, and expansion without slowing your momentum."
        button={{
          label: "View Funding Opportunities",
          onClick: () => {
            window.open(webUrl + "/funding", "_blank");
          },
        }}
      />

      {/* Section Five */}
      <PageSection
        imgSrc={sect5_img}
        greyBkg
        header={
          <>
            <span className="text-primaryDark-400">
              Learn From Industry Experts
            </span>{" "}
            Who’ve Done It Before
          </>
        }
        description="Get guidance from experienced chefs, operators, and food business professionals who can help you avoid costly mistakes, make smarter decisions, and grow your brand faster."
        button={{
          label: "View Industry Experts",
          onClick: () => {
            window.open(webUrl + "/expert", "_blank");
          },
        }}
      />

      {/* Section Six */}
      <PageSection
        imgSrc={sect6_img}
        header={
          <>
            <span className="text-primaryDark-400">
              Source Local, Fresh Ingredients
            </span>{" "}
            With Ease
          </>
        }
        description="Connect with trusted local suppliers for high-quality, fresh ingredients - helping you maintain great taste, control costs, and deliver consistent value to your customers."
        button={{
          label: "View Local Fresh Foods",
          onClick: () => {
            window.open(webUrl + "/farm", "_blank");
          },
        }}
      />

      {/* Section Seven */}
      <PageSection
        imgSrc={sect7_img}
        greyBkg
        header={
          <>
            <span className="text-primaryDark-400">Be part of a</span> Community
            That Moves You Forward
          </>
        }
        description="Connect with trusted local suppliers for high-quality, fresh ingredients - helping you maintain great taste, control costs, and deliver consistent value to your customers."
        button={{
          label: "View Communities",
          onClick: () => {
            window.open(webUrl + "/communities", "_blank");
          },
        }}
      />

      {/* How It Works Section */}
      <FoodHow />

      {/* Homecook Form */}
      <PageForm buttonLabel="Join" />
    </>
  );
};

export default FoodSections;
